
export const parseDate = (dateStr) => {
    if (!dateStr || typeof dateStr !== 'string') {
        console.warn('Fecha inválida recibida en parseDate:', dateStr);
        return;
    }

    const parts = dateStr.split(' ')[0].split('-');
    if (parts.length < 3 || !parts[1]) {
        console.warn('Formato incorrecto de fecha:', dateStr);
        return;
    }
    const day = parseInt(parts[0], 10);
    const month = { 'ene': 0, 'feb': 1, 'mar': 2, 'abr': 3, 'may': 4, 'jun': 5, 'jul': 6, 'ago': 7, 'sep': 8, 'oct': 9, 'nov': 10, 'dic': 11 }[parts[1].toLowerCase()];
    const year = parseInt(parts[2], 10);
    return new Date(year, month, day);
};

export const subtractDays = (days, date, setToEndOfDay = false) => {

    const result = new Date(date);
    result.setDate(date.getDate() - days);
    if (setToEndOfDay) {
        result.setHours(23, 59, 59, 999); // Final del día
    } else {
        result.setHours(0, 0, 0, 0); // Inicio del día
    }
    return result;
};

export const formatDate = (date) => {
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return new Date(date).toLocaleDateString('es-ES', options);
};


export const formatTime = (seconds) => {
    if (isNaN(seconds) || seconds === null || seconds === undefined) {
        return '0h 0m 0s'; // Si no es un número válido, retornar un tiempo por defecto
    }

    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return `${h}h ${m}m ${parseInt(s)}s`;
};

export const parseMonth = (month) => {
    const months = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    const index = months.indexOf(month);
    return index !== -1 ? index : null; // Retorna el índice o null si no existe
};

export const startOfDay = (date) => new Date(date.setHours(0, 0, 0, 0));
export const endOfDay = (date) => new Date(date.setHours(23, 59, 59, 999));

export const formatDateRange = (range, day, startWeek, endWeek, startMonth, endMonth) => {
    if (range === 0) {
        return day.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
    } else if (range === 1) {
        return `${startWeek.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' })} - ${endWeek.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' })}`;
    } else {
        return `${startMonth.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' })} - ${endMonth.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' })}`;
    }
};

export const filterMileageReport = (dataReport, startDate, endDate) => {
    const daysArray = [];
    let currentDay = new Date(startDate);

    while (currentDay <= new Date(endDate)) {
        daysArray.push(new Date(currentDay));
        currentDay.setDate(currentDay.getDate() + 1);
    }

    const transformedData = {
        objects: dataReport.report.sheets.map(sheet => {
            const obj = {
                name: sheet.header,
                summary: sheet.sections.flatMap(section => section.rows || []),
                data: sheet.header !== "Período Resumen"
                    ? sheet.sections.flatMap(section =>
                        (section.data || []).map(dataItem => ({
                            date: dataItem.header,
                            total: dataItem.total
                        }))
                    )
                    : []
            };
            return obj;
        })
    };

    return daysArray.map((day) => {
        const dayData = { date: day };

        transformedData.objects.forEach(obj => {
            dayData[obj.name] = { mileage: 0, time: 0 };

            if (obj.data) {
                const carData = obj.data.find(entry => {
                    const entryDate = parseDate(entry.date);
                    return entryDate.toDateString() === day.toDateString();
                });

                if (carData) {
                    const mileage = carData.total.length.raw || 0;
                    const time = carData.total.time?.raw || 0; // Usa `0` si `time.raw` no está definido o no es un número
                    dayData[obj.name] = { mileage, time };
                }

            }
        });

        return dayData;
    });
}

export const filterStoppedTimeReport = (dataReport, startDate, endDate) => {
    const daysArray = [];
    let currentDay = new Date(startDate);

    while (currentDay <= endDate) {
        daysArray.push(new Date(currentDay));
        currentDay.setDate(currentDay.getDate() + 1);
    }

    return daysArray.map((day) => {
        const dayData = { date: day };

        dataReport.report.sheets.forEach(sheet => {
            // Inicializar datos para cada carro
            dayData[sheet.header] = {
                ignition_on: 0,
                idle_duration: 0,
                ignition_on_percent: 0,
            };

            const tableSection = sheet.sections.find(section => section.type === 'table');

            if (tableSection) {
                const carData = tableSection.data.find(entry => {
                    const entryDate = parseDate(entry.header);
                    return entryDate.toDateString() === day.toDateString();
                });

                if (carData && carData.total) {
                    const ignitionOn = carData.total.ignition_on?.raw || 0;
                    const idleDuration = carData.total.idle_duration?.raw || 0;
                    const ignitionOnPercent = carData.total.ignition_on_percent?.raw || 0;

                    dayData[sheet.header] = {
                        ignition_on: ignitionOn,
                        idle_duration: idleDuration,
                        ignition_on_percent: ignitionOnPercent,
                    };
                }
            }
        });

        return dayData;
    });
}

export const filterSpeedViolationReport = (dataReport, startDate, endDate) => {
    const daysArray = [];
    let currentDay = new Date(startDate);

    while (currentDay <= endDate) {
        daysArray.push(new Date(currentDay));
        currentDay.setDate(currentDay.getDate() + 1);
    }

    return daysArray.map((day) => {
        const dayData = { date: day };

        dataReport.report.sheets.forEach(sheet => {
            dayData[sheet.header] = [];

            const tableSection = sheet.sections.find(section => section.type === 'table');

            if (tableSection) {
                const carData = tableSection.data.find(entry => {
                    const entryDate = parseDate(entry.header);
                    return entryDate.toDateString() === day.toDateString();
                });

                if (carData && carData.rows) {
                    dayData[sheet.header] = carData.rows.map((row) => {
                        return {
                            duration: row.duration.raw || 0,
                            start_time: row.start_time.raw || 0,
                            avg_speed: row.avg_speed.raw || 0,
                            max_speed: row.max_speed.raw || 0,
                        };
                    });
                }
            }
        });

        return dayData;
    });
}

export const filterRalentiReport = (dataReport, startDate, endDate) => {
    const daysArray = [];
    let currentDay = new Date(startDate);

    while (currentDay <= endDate) {
        daysArray.push(new Date(currentDay));
        currentDay.setDate(currentDay.getDate() + 1);
    }

    return daysArray.map((day) => {
        const dayData = { date: day };

        dataReport.report.sheets.forEach((sheet) => {
            const carName = sheet.header;

            // Encuentra la sección de 'table' y filtra las filas correspondientes al día actual
            const tableSection = sheet.sections.find(section => section.type === 'table');
            if (tableSection) {
                // Filtrar por la fecha utilizando `toDateString` para evitar comparar horas
                const row = tableSection.data?.find((item) =>
                    item.rows.find((r) => parseDate(r.date.v).toDateString() === day.toDateString())
                )?.rows.find(r => parseDate(r.date.v).toDateString() === day.toDateString());

                if (row) {
                    dayData[carName] = {
                        mileage: row.mileage.raw || 0,
                        duration: row.duration?.raw || 0,
                        idle: row.idle?.raw || 0,
                        avg_period: row.avg_period?.raw || 0,
                        avg_speed: row.avg_speed?.raw || 0,
                        in_movement: row.in_movement?.raw || 0,
                        percent_in_movement: row.percent_in_movement?.raw || 0,
                        percent_idle: row.percent_idle?.raw || 0,
                        period_count: row.period_count?.raw || 0,
                    };
                } else {
                    // Si no hay datos para este día, insertar ' — ' como valor
                    dayData[carName] = {
                        mileage: ' — ',
                        duration: ' — ',
                        idle: ' — ',
                        avg_period: ' — ',
                        avg_speed: ' — ',
                        in_movement: ' — ',
                        percent_in_movement: ' — ',
                        percent_idle: ' — ',
                        period_count: ' — '
                    };
                }
            }
        });

        return dayData;
    });
}

export const filterFuelReport = (dataReport, startDate, endDate) => {
    const daysArray = [];
    let currentDay = new Date(startDate);

    while (currentDay <= endDate) {
        daysArray.push(new Date(currentDay));
        currentDay.setDate(currentDay.getDate() + 1);
    }

    return daysArray.map((day) => {
        const dayData = { date: day };

        // Recorremos cada sheet (vehículo) del reporte
        dataReport.report.sheets.forEach((sheet) => {
            dayData[sheet.header] = {}; // Inicializamos el objeto para almacenar los datos del vehículo

            // Buscamos la sección que tiene los "Detalles por fechas" y el tipo "table"
            const tableSection = sheet.sections.find(
                (section) => section.header === 'Detalles por fechas' && section.type === 'table'
            );

            if (tableSection && tableSection.data) {

                const carData = tableSection.data?.find((item) =>
                    item.rows.find((r) => r.date.v !== 'En total:*' && r.date.v !== 'En total:' && parseDate(r.date.v).toDateString() === day.toDateString())
                )?.rows.find(r => r.date.v !== 'En total:*' && r.date.v !== 'En total:' && parseDate(r.date.v).toDateString() === day.toDateString());

                if (carData) {
                    // Mapeamos los datos relevantes de cada fila del día
                    dayData[sheet.header] = {
                        consumed: Number(carData.consumed.raw) || 0,
                        fillingsCount: Number(carData.fillingsCount.raw) || 0,
                        drainsCount: Number(carData.drainsCount.raw) || 0,
                        start: Number(carData.start.raw) || 0,
                        end: Number(carData.end.raw) || 0,
                        drainsVolume: Number(carData.drainsVolume.raw) || 0,
                        mileage_by_gps: Number(carData.mileage_by_gps.raw) || 0,
                        consumption_per_dist: Number(carData.consumption_per_dist.raw) || 0,
                        fillingsVolume: Number(carData.fillingsVolume.raw) || 0
                    };
                }
            }
        });

        return dayData;
    });
}

export const filterFuelRefillsReport = (dataReport, startDate, endDate) => {
    const daysArray = [];
    let currentDay = new Date(startDate);

    while (currentDay <= endDate) {
        daysArray.push(new Date(currentDay));
        currentDay.setDate(currentDay.getDate() + 1);
    }

    const vehicleRefills = {};

    // Recorrer cada hoja para procesar los vehículos
    dataReport.report.sheets.forEach((sheet) => {
        const vehicle = sheet.header; // Nombre del vehículo
        const section = sheet.sections.find(
            (s) => s.header === 'Rellenos y desagües' && s.type === 'table'
        );

        if (section && section.data) {
            const refills = [];

            section.data.forEach((entry) => {
                entry.rows.forEach((row) => {
                    if (row.type.v === 'Relleno') {
                        const refillDate = new Date(row.time.raw); // Convertir timestamp
                        refills.push({
                            volume: row.volume.raw,
                            date: refillDate,
                        });
                    }
                });
            });

            // Ordenar los rellenos por fecha descendente y limitar a los últimos 5
            vehicleRefills[vehicle] = refills
                .sort((a, b) => b.date - a.date)
                .slice(0, 5);

            // Rellena con valores vacíos si hay menos de 5 elementos
            while (vehicleRefills[vehicle].length < 5) {
                vehicleRefills[vehicle].push({ volume: null, date: null });
            }
        } else {
            // Si no hay datos, inicializar con un array vacío
            vehicleRefills[vehicle] = [];
            while (vehicleRefills[vehicle].length < 5) {
                vehicleRefills[vehicle].push({ volume: null, date: null });
            }
        }
    });

    return vehicleRefills;
}

// Extraer datos de dataReport[0]
export const extractReport0Data = (report, formattedDay) => {
    const dayData = { date: formattedDay };
    report.report.sheets.forEach(sheet => {
        sheet.sections.forEach(section => {
            if (section.type === "table" && section.data) {
                section.data.forEach(dataEntry => {
                    dataEntry.rows.forEach(row => {
                        const fromDate = new Date(row.from.raw);
                        if (fromDate.toDateString() === formattedDay) {
                            const vehicle = sheet.header;
                            if (!dayData[vehicle]) {
                                dayData[vehicle] = [];
                            }
                            dayData[vehicle].push({ from: row.from.raw, to: row.to.raw });
                        }
                    });
                });
            }
        });
    });
    return dayData;
};

// Extraer datos de dataReport[1]
export const extractReport1Data = (report, formattedDay) => {
    const dayData = { date: formattedDay };
    report.report.sheets.forEach(sheet => {
        sheet.sections.forEach(section => {
            if (section.type === "table" && section.data) {
                section.data.forEach(dataEntry => {
                    dataEntry.rows.forEach(row => {
                        const fromDate = new Date(row.time.raw);
                        const vehicle = sheet.header;
                        if (!dayData[vehicle]) {
                            dayData[vehicle] = [];
                        }
                        if (fromDate.toDateString() === formattedDay) {
                            dayData[vehicle].push({
                                time: row.time.raw,
                                event: row.event.v,
                            });
                        }
                    });
                });
            }
        });
    });
    return dayData;
};

export const processData = (report, extractDataCallback, type, startDate, endDate) => {
    const daysArray = [];
    let currentDay = new Date(startDate);

    while (currentDay <= endDate) {
        daysArray.push(new Date(currentDay));
        currentDay.setDate(currentDay.getDate() + 1);
    }

    return daysArray.map(day => {
        const formattedDay = day.toDateString();
        const dayData = extractDataCallback(report, formattedDay);

        report.report.sheets.forEach(sheet => {
            sheet.sections.forEach(section => {
                if (section.type === 'table' && section.data) {
                    section.data.forEach(dataEntry => {
                        dataEntry.rows.forEach(row => {
                            const fromDate = type === 'trips' ? new Date(row.from.raw) : new Date(row.time.raw);
                            const vehicle = sheet.header;
                            if (!dayData[vehicle]) {
                                dayData[vehicle] = [];
                            }
                            if (fromDate.toDateString() === formattedDay) {
                                if (type === 'trips') {
                                    dayData[vehicle].push({
                                        from: row.from.raw,
                                        to: row.to.raw
                                    });
                                } else if (type === 'events') {
                                    dayData[vehicle].push({
                                        time: row.time.raw,
                                        event: row.event.v,
                                    });
                                }
                            }
                        });
                    });
                }
            });
        });
        return dayData;
    }
    )
};

export const filterReportData = (dataReport, title, startDate, endDate) => {

    switch (title) {
        case 'Kilometraje':
            return filterMileageReport(dataReport, subtractDays(59, new Date(endDate)), endDate);

        case 'Tiempo detenido':
            return filterStoppedTimeReport(dataReport, subtractDays(59, new Date(endDate)), endDate);

        case 'Excesos de velocidad':
            return filterSpeedViolationReport(dataReport, subtractDays(59, new Date(endDate)), endDate);

        case 'Ralentí':
            return filterRalentiReport(dataReport, subtractDays(59, new Date(endDate)), endDate);

        case 'Combustible':
            return filterFuelReport(dataReport, subtractDays(59, new Date(endDate)), endDate);

        case 'Tiempo de trabajo':
            const processedTripsData = processData(dataReport[0], extractReport0Data, 'trips', subtractDays(59, new Date(endDate)), endDate);
            const processedEventsData = processData(dataReport[1], extractReport1Data, 'events', subtractDays(59, new Date(endDate)), endDate);
            return { trips: [...processedTripsData], events: [...processedEventsData] };

        default:
            break;
    }


}